// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MegaMenu_dropdown__x4kZ0","fadeInDropdown":"MegaMenu_fadeInDropdown__jwu3d"};